import { render, staticRenderFns } from "./TeachersView.vue?vue&type=template&id=07e41708&scoped=true"
import script from "./TeachersView.vue?vue&type=script&lang=js"
export * from "./TeachersView.vue?vue&type=script&lang=js"
import style0 from "./TeachersView.vue?vue&type=style&index=0&id=07e41708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e41708",
  null
  
)

export default component.exports